__turbopack_context__.v({
  "animatedGradientText": "GradientText-module-scss-module__9UmGYW__animatedGradientText",
  "gradient": "GradientText-module-scss-module__9UmGYW__gradient",
  "gradientOverlay": "GradientText-module-scss-module__9UmGYW__gradientOverlay",
  "gradientShift": "GradientText-module-scss-module__9UmGYW__gradientShift",
  "textContent": "GradientText-module-scss-module__9UmGYW__textContent",
});
